export default [
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    animationDuration: '2.4s',
    animationDelay: '0.5s',
    position: { top: '25px', left: '-22px' },
  },
  {
    icon: 'star',
    color: '#1f9bbf',
    size: 16,
    animationDuration: '2.3s',
    position: { bottom: '-5px', left: '-16px' },
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { bottom: '18px', left: '8px' },
    animationDuration: '2.2s',
    animationDelay: '0.2s',
  },
  {
    icon: 'star',
    color: '#1f9bbf',
    size: 16,
    position: { top: '-22px', left: '124px' },
    animationDuration: '2.1s',
  },
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    position: { top: '5px', right: '45px' },
    animationDuration: '2.5s',
    animationDelay: '0.7s',
  },
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    position: { top: '60px', right: '-22px' },
    animationDuration: '3s',
  },
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    position: { bottom: '-22px', right: '52px' },
    animationDuration: '2.1s',
    animationDelay: '0.3s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { top: '10px', right: '175px' },
    animationDuration: '2.6s',
    animationDelay: '1s',
  },
  {
    icon: 'star',
    color: '#1f9bbf',
    size: 16,
    position: { top: '-18px', right: '0px' },
    animationDuration: '2.8s',
    animationDelay: '0.1s',
  },
].map((item, key) => ({ ...item, key }));
